export default {
  // Loại nền tảng quảng cáo (cho i18n)
  'adsPlatform.80004001': 'Google',
  'adsPlatform.80004002': 'Facebook',
  'adsPlatform.80004003': 'Twitter',
  'adsPlatform.80004004': 'TikTok',
  'adsPlatform.80004005': 'Adjust',
  'adsPlatform.80004006': 'SGTM',
  // Loại sự kiện quy kết (cho i18n)
  'adsEvent.80005001': 'Đăng ký',
  'adsEvent.80005002': 'Nạp lần đầu',
  'adsEvent.80005003': 'Nạp lại',
  // Loại trạng thái tải lên (cho i18n)
  'adsPushStatus.80006001': 'Đang tải lên',
  'adsPushStatus.80006002': 'Tải lên thất bại',
  'adsPushStatus.80006003': 'Tải lên thành công',
  // Tiêu đề trang
  'adsAccount.title': 'Danh sách tài khoản quảng cáo',

  // Trường tìm kiếm
  'adsAccount.platform': 'Nền tảng quy kết',
  'adsAccount.name': 'Tên quy kết',

  // Nút
  'adsAccount.search': 'Tìm kiếm',
  'adsAccount.reset': 'Đặt lại',
  'adsAccount.add': 'Thêm',
  'adsAccount.edit': 'Chỉnh sửa',
  'adsAccount.delete': 'Xóa',
  'adsAccount.save': 'Lưu',
  'adsAccount.cancel': 'Hủy',

  // Cột bảng
  'adsAccount.serial': 'Số thứ tự',
  'adsAccount.platform': 'Nền tảng quy kết',
  'adsAccount.name': 'Tên quy kết',
  'adsAccount.adsId': 'ID tài khoản nền tảng',
  'adsAccount.conversionId': 'ID chuyển đổi',
  'adsAccount.gtmId': 'GTM-ID',
  'adsAccount.mccAccount': 'Tài khoản MCC liên kết',
  'adsAccount.accessToken': 'Token truy cập',
  'adsAccount.clientId': 'OAuth Client ID',
  'adsAccount.registerEventPath': 'Mã sự kiện đăng ký',
  'adsAccount.firstRechargeEventPath': 'Mã sự kiện nạp đầu tiên',
  'adsAccount.rechargeEventPath': 'Đường dẫn sự kiện nạp lại',
  'adsAccount.registerConversionLabel': 'Nhãn chuyển đổi đăng ký (GTM)',
  'adsAccount.firstRechargeConversionLabel': 'Nhãn chuyển đổi nạp đầu tiên (GTM)',
  'adsAccount.repeatRechargeConversionLabel': 'Nhãn chuyển đổi nạp lại (GTM)',
  'adsAccount.status': 'Trạng thái',
  'adsAccount.otherParams': 'Tham số quy kết',
  'adsAccount.action': 'Hành động',

  // Trạng thái
  'adsAccount.active': 'Hoạt động',
  'adsAccount.inactive': 'Không hoạt động',

  // Xác thực biểu mẫu
  'adsAccount.platformRequired': 'Vui lòng chọn nền tảng quy kết',
  'adsAccount.nameRequired': 'Vui lòng nhập tên quy kết',
  'adsAccount.adsIdRequired': 'Vui lòng nhập ID tài khoản nền tảng',
  'adsAccount.conversionIdRequired': 'Vui lòng nhập ID chuyển đổi',
  'adsAccount.mccAccountRequired': 'Vui lòng chọn tài khoản MCC liên kết',
  'adsAccount.mccAccountPlaceholder': 'Vui lòng nhập tài khoản MCC liên kết',
  'adsAccount.accessTokenRequired': 'Vui lòng nhập token truy cập',
  'adsAccount.clientIdRequired': 'Vui lòng nhập OAuth Client ID',
  'adsAccount.registerEventPathRequired': 'Vui lòng nhập mã sự kiện đăng ký',
  'adsAccount.firstRechargeEventPathRequired': 'Vui lòng nhập mã sự kiện nạp đầu tiên',
  'adsAccount.repeatRechargeEventPathRequired': 'Vui lòng nhập đường dẫn sự kiện nạp lại',

  // Placeholder biểu mẫu
  'adsAccount.namePlaceholder': 'Vui lòng nhập tên quy kết',
  'adsAccount.adsIdPlaceholder': 'Vui lòng nhập ID tài khoản nền tảng',
  'adsAccount.conversionIdPlaceholder': 'Vui lòng nhập ID chuyển đổi',
  'adsAccount.registerEventPathPlaceholder': 'Ví dụ: /register/123',
  'adsAccount.firstRechargeEventPathPlaceholder': 'Ví dụ: /recharge/123',
  'adsAccount.registerConversionLabelPlaceholder': 'Ví dụ: 5txfCOaKzuwbEOPCia9A',
  'adsAccount.firstRechargeConversionLabelPlaceholder': 'Ví dụ: 5txfCOaKzuwbEOPCia9A',
  'adsAccount.repeatRechargeConversionLabelPlaceholder': 'Ví dụ: 5txfCOaKzuwbEOPCia9A',

  // Tiêu đề modal
  'adsAccount.addAdsAccount': 'Thêm cấu hình quy kết quảng cáo',
  'adsAccount.editAdsAccount': 'Chỉnh sửa cấu hình quy kết quảng cáo',

  // Thông báo
  'adsAccount.addSuccess': 'Thêm thành công',
  'adsAccount.addFailed': 'Thêm thất bại',
  'adsAccount.editSuccess': 'Cập nhật thành công',
  'adsAccount.editFailed': 'Cập nhật thất bại',
  'adsAccount.deleteSuccess': 'Xóa thành công',
  'adsAccount.deleteFailed': 'Xóa thất bại',
  'adsAccount.confirmDelete': 'Bạn có chắc chắn muốn xóa bản ghi này không?',
  'adsAccount.validationError': 'Vui lòng điền tất cả các trường bắt buộc',
  'adsAccount.fetchDataFailed': 'Không thể tải dữ liệu',
  'adsAccount.fetchTypesFailed': 'Không thể tải loại nền tảng quy kết',
  'adsAccount.fetchMccAccountsFailed': 'Không thể tải danh sách tài khoản MCC',
  'adsAccount.noData': 'Không có dữ liệu',

  // Phân trang
  'adsAccount.totalRecords': 'Tổng cộng {total} bản ghi',
  'adsAccount.pagination': 'Trang {current} của {page}, Tổng cộng {total} bản ghi',
};
